import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase.config';

function AdminPage() {
    const [currentUser, setCurrentUser] = useState(null);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (currentUser) {
            fetchUsers();
        }
    }, [currentUser]);

    const fetchUsers = async () => {
        try {
            const usersCollection = collection(db, 'users');
            const usersSnapshot = await getDocs(usersCollection);
            const usersData = usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setUsers(usersData);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    if (!currentUser) {
        return <p>Loading...</p>;
    }

    if (!isAdmin(currentUser)) {
        return <p>Access denied. You must be an admin to view this page.</p>;
    }

    return (
        <div>
            <h1>Admin Page</h1>
            <p>Welcome, {currentUser.email}</p>
            <h2>Users:</h2>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                <ul>
                    {users.map((user) => (
                        <li key={user.id}>
                            <Link to={`/user-profile/${user.id}`}>
                                {user.email}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <Link to="/">Back to Home</Link>
        </div>
    );
}

function isAdmin(user) {
    // Add logic to determine if the user is an admin
    return user.email === 'drilon_p@hotmail.com'; // Example: check user's email
}

export default AdminPage;